import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import cancellationPolicyService from '../services/cancellationPolicyService'
import PolicyDisplay from '../components/PolicyDisplay'
import Loader from '../components/Loader'

/**
 * Standalone public page for the active Cancellation Policy version.
 * Linked from Footer and cross-referenced from Terms & Conditions.
 */
const CancellationPolicy = () => {
  const [policy, setPolicy] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    cancellationPolicyService
      .getActive('cancellation')
      .then((resp) => {
        if (!cancelled) setPolicy(resp?.policy || null)
      })
      .catch((err) => {
        console.error('cancellation_policy_load_error', err)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="container mx-auto max-w-3xl px-4 py-8">
      <Helmet>
        <title>Cancellation Policy · Himachal Yatra</title>
        <meta
          name="description"
          content="Himachal Yatra's cancellation and refund policy for tours, treks, and services."
        />
      </Helmet>
      <h1 className="mb-6 text-3xl font-bold text-gray-900">Cancellation Policy</h1>
      {loading ? (
        <Loader />
      ) : (
        <PolicyDisplay
          policy={policy}
          title="Cancellation Policy"
          defaultOpen
          proseSize="prose-base"
        />
      )}
      {policy && (
        <p className="mt-4 text-xs text-gray-500">
          Version <span className="font-mono">{policy.version}</span>
        </p>
      )}
    </div>
  )
}

export default CancellationPolicy
